import React from 'react'
import WorkerReportView from './WorkerReportView'
import { useWorkerReport } from './useWorkerReport'
const WorkerReport = (): JSX.Element => {
  const state = useWorkerReport()
  return <WorkerReportView {...state} />
}

export default WorkerReport
